<template>
  <div class="box-side">
    <a :href="lien" :title="nomImage" class="image"><img :src="imagePath" :alt="alt" :title="alt"/></a>
    <h4> {{ titlebox }} </h4>
    <p><slot></slot></p>
    <bouton :href="lien" :class="classbt"> {{ txtbouton }} </bouton>
  </div> 
</template>

<script>
  import Bouton from '@/components/Bouton'
  export default {
    props: ['lien', 'imagePath', 'txtbouton', 'titlebox', 'classbt'],
    components: { Bouton },
    computed: {
      alt () {
        let explodedPath =  this.imagePath.split('/')
        let imageName = explodedPath[explodedPath.length - 1]
        return imageName.split('.')[0]
      }
    }
  }
</script>

<style>
  .box-side  {
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 20px;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.2); 
    margin-bottom: 40px;  
    text-align: left;
  }
  .box-side img  {      
  }
  .box-side h4  {  
    font-size: 24px;
    color: #413492;
    line-height: 26px;
    margin-bottom: 20px;
    }
  .box-side p  {  font-size: 14px; }
  .box-side .button {  width: 100%; }
  
  .button.heart:before {
    content: "\f004";
    font: normal normal normal 21px/1 FontAwesome;
    display: inline-block;
    margin-right: 10px;
    top: 1px;
    position: relative;
  }
  
</style>
